import Vue from 'vue'
import VueAMap from 'vue-amap'; // 高德地图

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '4199fe377dd77297c6e4cee01bd0b266',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation',
    'AMap.Geocoder'
  ],
  v: '1.4.4'
})



// WEBPACK FOOTER //
// ./src/plugin/amap.js